import { connect } from 'react-redux';
import ProjectDetails from 'components/feature/project-details/project-details-component';
import {
  initProjectSocketClient,
  setProjectSocketClient,
  closeProjectSocketClient,
} from 'store/actions/project-socket-actions';

const mapStateToProps = ({ data }) => {
  const {
    projectList,
    selectedProject: { project },
  } = data;
  return {
    projectList,
    project,
    stateData: data,
  };
};

const mapDispatchToProps = {
  initProjectSocketClient,
  setProjectSocketClient,
  closeProjectSocketClient,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetails);
